import React, { useState } from 'react';

// Generate a deterministic color based on a string (name or email)
const getDeterministicColor = (identifier) => {
  if (!identifier) return '#6b7280'; // gray-500 fallback
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colors = [
    '#ef4444', // red-500
    '#f97316', // orange-500
    '#eab308', // yellow-500
    '#22c55e', // green-500
    '#14b8a6', // teal-500
    '#3b82f6', // blue-500
    '#6366f1', // indigo-500
    '#a855f7', // purple-500
    '#ec4899', // pink-500
  ];
  return colors[Math.abs(hash) % colors.length];
};

export const UserAvatar = ({ user, className = 'h-9 w-9' }) => {
  const [imgError, setImgError] = useState(false);

  // Fallback to email or '?' if name is missing
  const identifier = user?.name || user?.email || '?';
  const initial = identifier.charAt(0).toUpperCase();
  const backgroundColor = getDeterministicColor(identifier);

  // Check common picture fields
  const picture = user?.picture || user?.photo_url || user?.profilePicture;

  // Render initial fallback if no image or image failed to load
  if (!picture || imgError) {
    return (
      <div
        className={`flex shrink-0 items-center justify-center rounded-full font-bold text-white ${className}`}
        style={{ backgroundColor }}
        title={identifier}
      >
        {initial}
      </div>
    );
  }

  // Combine standard classes with custom ones
  const combinedClassName = `rounded-full object-cover shrink-0 ${className}`;

  return (
    <img
      src={picture}
      alt={identifier}
      className={combinedClassName}
      onError={() => setImgError(true)}
      title={identifier}
    />
  );
};
